import React, { Component } from "react"
import Link from "gatsby-link"
import PostIntro from "../components/Linking/postIntro"
import PostFilter from "../components/Linking/postFilter"
import BlogListAside from "../components/Containers/blogListAside"
import Helmet from "react-helmet"
 
const NavLink = props => {
  if (!props.test) {
    return <Link to={props.url}>{props.text}</Link>;
  } else {
    return <span>{props.text}</span>;
  }
};
 
const CategoryPage = ({ data, pathContext }) => {
  const { group, index, first, last, pageCount, pathPrefix } = pathContext;
  const previousUrl = index - 1 == 1 ? "/blog/" : (index - 1).toString();
  const nextUrl = (index + 1).toString();
  const currentCategory = pathContext.pathPrefix.split("/")[1]

 
  return (
    <div>
     
     <Helmet>
        <meta name="description" content="Aprende diseño y desarrollo web. Encuentra tutoriales y reviews de libros sobre diseño, programación y emprendizaje." />
        <title>Diseño y desarrollo web (tutoriales, libros y más) | @gmugart</title>
    </Helmet>
     <PostFilter currentCategory={currentCategory} borders={true} filterText={"Filtrar:"} />
     <div className="blog-list-container">
      {group.map(({ node }) => (
       <div key={node.id}>     
          <BlogListAside category={node.frontmatter.category} date={node.frontmatter.date}/>
        <div className="blogListing">
          <PostIntro key={node.id} post={node} />
        </div>
        </div> 
      ))}

          </div>
          
          <div className="previousLink">
        <NavLink test={first} url={previousUrl} text="&#x2190; Página anterior" />
      </div>
      <div className="nextLink">
        <NavLink test={last} url={nextUrl} text="Siguiente página &#x2192;" />
      </div>
    </div>
  );
};
export default CategoryPage;



/*
const Category = ({ pathContext, data }) => {
    console.log("data");
    console.log(data);
  const { categoryItem } = pathContext;
  const { edges, totalCount } = data.allMarkdownRemark;
  const categoryHeader = `${totalCount} post${totalCount === 1 ? '' : 's'} tagged with "${categoryItem}"`;

  return (
    <div>
      <h1>{categoryHeader}</h1>
      <ul>
        {edges.map(({ node }) => {
          const { path, title } = node.frontmatter;
          return (
            <li key={path}>
              <Link to={path}>{title}</Link>
            </li>
          );
        })}
      </ul>
      {/*
        This links to a page that does not yet exist.
        We'll come back to it!
      *//*}
      <Link to="/category">All category</Link>
    </div>
  );
};

Category.propTypes = {
  pathContext: PropTypes.shape({
    categoryItem: PropTypes.string.isRequired,
  }),
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      totalCount: PropTypes.number.isRequired,
      edges: PropTypes.arrayOf(
        PropTypes.shape({
          node: PropTypes.shape({
            frontmatter: PropTypes.shape({
              path: PropTypes.string.isRequired,
              title: PropTypes.string.isRequired,
            }),
          }),
        }).isRequired,
      ),
    }),
  }),
};


export default Category;*/
/*
export const pageQuery = graphql`
 query CategoryPage($categoryItem: String){
      allMarkdownRemark(
        limit: 2000
        sort: { fields: [frontmatter___date], order: DESC }
        filter: {
          frontmatter: { category:{
          eq: $categoryItem
      } }
    }
        ) {
        totalCount
        edges {
          node {
            frontmatter {
              title
              path
            }
          }
        }
      }
    }
`;*/


// WEBPACK FOOTER //
// ./src/templates/categoryListTemplate.js